import { useCurrentEnterpriseId } from '@mews-commander/core';
import { isAnyClientEnterpriseIntegrationsEnabled } from '@mews-commander/legacy-entities/src/ducks/enterpriseIntegrations';
import { isCurrentEnterpriseAvailabilityBlockBookingEngineLinksEnabled } from '@mews-commander/legacy-entities/src/selectors/session/subscription';
import { useCommanderSelector } from '@mews-commander/utils';
import { getPlatformEnvironment } from '../../app/reducers/configuration';
import { getBookingEngineUpsellingApplicationId } from './bookingEngineLink';

export const useBookingEngineLinkEnabled = () => {
    const environment = useCommanderSelector(getPlatformEnvironment);
    const enterpriseId = useCurrentEnterpriseId();
    const applicationId = getBookingEngineUpsellingApplicationId(environment);

    const integrationEnabled: boolean = useCommanderSelector((state) =>
        isAnyClientEnterpriseIntegrationsEnabled(state, { enterpriseId, clientId: applicationId })
    );

    const enabled: boolean = useCommanderSelector(isCurrentEnterpriseAvailabilityBlockBookingEngineLinksEnabled);

    return integrationEnabled || enabled;
};
